import { api, tagTypes } from "./api";
import type {
  RequestTypes,
  WithdrawalApiResponse,
  UserRequestResponse,
  ArtisanRequestResponse,
} from "../features/requestSlice";

export interface ValidateRequestParams {
  transaction_id: string;
  action: string;
}

export interface ProcessWithdrawalParams {
  userType: string;
  status: "approved" | "rejected";
  withdrawalId: string;
}


type PaginationParams = {
  page?: number;
  limit?: number;
  status?: string;
  source?: string;
};
// Inject request endpoints into the main API
export const requestApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // Get all user withdrawal requests
    getAllUserRequests: builder.query<UserRequestResponse, PaginationParams, void>({
      query: ({ page = 1, limit = 10 }) => ({
        url: "user/v1/admin/wallet/withdraw-request",
        params: { page, limit },
        method: "GET",
      }),
      providesTags: [tagTypes.Transaction],
    }),

    // Get all artisan withdrawal requests
    getAllArtisanRequests: builder.query<ArtisanRequestResponse, PaginationParams, void>({
      query: ({ page = 1, limit = 10 }) => ({
        url: "user/v1/admin/wallet/withdraw-request",
        params: { page, limit },
        method: "GET",
      }),
      providesTags: [tagTypes.Transaction],
    }),

    // Get all withdrawal requests (combined)
    getAllWithdrawalRequests: builder.query<WithdrawalApiResponse, PaginationParams, void>({
      query: ({ page = 1, limit = 10, status='', source = '' }) => ({
        url: "booking/v1/admin/withdrawal_request",
        params: { page, limit, status, source },
        method: "GET",
      }),
      providesTags: [tagTypes.Transaction],
    }),

    // Validate user request
    validateUserRequest: builder.mutation<any, ValidateRequestParams>({
      query: ({ transaction_id, action }) => ({
        url: `user/v1/admin/wallet/withdraw-request/:${transaction_id}?action=${action}`,
        method: "PUT",
      }),
      invalidatesTags: [tagTypes.Transaction],
    }),

    // Validate artisan request
    validateArtisanRequest: builder.mutation<any, ValidateRequestParams>({
      query: ({ transaction_id, action }) => ({
        url: `artisan/v1/admin/wallet/withdraw-request/:${transaction_id}?action=${action}`,
        method: "PUT",
      }),
      invalidatesTags: [tagTypes.Transaction],
    }),

    // Process withdrawal request
    processWithdrawalRequest: builder.mutation<any, ProcessWithdrawalParams>({
      query: ({ userType, status, withdrawalId }) => ({
        url: "booking/v1/admin/withdrawal_request/action",
        method: "POST",
        body: {
          userType,
          status,
          withdrawalId,
        },
      }),
      invalidatesTags: [tagTypes.Transaction],
    }),
  }),
});

export const {
  useGetAllUserRequestsQuery,
  useLazyGetAllUserRequestsQuery,
  useGetAllArtisanRequestsQuery,
  useLazyGetAllArtisanRequestsQuery,
  useGetAllWithdrawalRequestsQuery,
  useLazyGetAllWithdrawalRequestsQuery,
  useValidateUserRequestMutation,
  useValidateArtisanRequestMutation,
  useProcessWithdrawalRequestMutation,
} = requestApi;
